import { render, staticRenderFns } from "./LaborRegistMonthly.vue?vue&type=template&id=6d70d213&scoped=true&"
import script from "./LaborRegistMonthly.vue?vue&type=script&lang=ts&"
export * from "./LaborRegistMonthly.vue?vue&type=script&lang=ts&"
import style0 from "./LaborRegistMonthly.vue?vue&type=style&index=0&id=6d70d213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70d213",
  null
  
)

export default component.exports